/**
 * mutates the applicant.payors.data property with the data given and
 * sets the applicant.payors.retrieved = true
 */
export const getAllPayors = (state, data) => {
  state.applicant.payors.data = data;
  state.applicant.payors.retrieved = true;
};
